var InlineDialogSimpleXdmDefinitionBuilder = /** @class */ (function () {
    function InlineDialogSimpleXdmDefinitionBuilder(inlineDialogProvider) {
        if (!inlineDialogProvider) {
            throw new Error('inlineDialogProvider is not defined');
        }
        this.inlineDialogProvider = inlineDialogProvider;
    }
    InlineDialogSimpleXdmDefinitionBuilder.prototype.buildSimpleXdmDefinition = function () {
        return {
        // This is not implemented yet. The implication of this is that inline dialogs must use the
        // module definition defined in the atlassian-connect-js repo which switches between the AUI
        // implementation and module provider implementation.
        };
    };
    return InlineDialogSimpleXdmDefinitionBuilder;
}());
export { InlineDialogSimpleXdmDefinitionBuilder };
//# sourceMappingURL=InlineDialogSimpleXdmDefinitionBuilder.js.map